export default __webpack_public_path__ + "static/media/story_other-4.745114b4.png";